/**
 * Which rows a management list shows, and how many it is withholding.
 *
 * Pure, and in lib/ for the reason scanBuffer.ts gives: the part that can
 * be wrong is the arithmetic, and arithmetic should be testable without a
 * DOM. What sits around it is a checkbox.
 *
 * Shaped for any list rather than devices alone, because Devices, People
 * and Tasks all draw the same one: live rows by default, retired ones
 * behind a counted switch.
 *
 * The count is taken from the whole set, never from what is on screen. A
 * switch reading "Show revoked devices (0)" while five are hidden is
 * worse than no switch — it is an assurance that nothing is missing.
 */
export type ActiveSplit<T> = {
  /** The rows to render, in the order they were given. */
  listed: T[];
  /** How many are inactive, shown or not. Zero means hide the switch. */
  hiddenCount: number;
};

export function splitByActive<T extends { active: boolean }>(
  rows: readonly T[],
  showRetired: boolean,
): ActiveSplit<T> {
  return {
    // Order is the server's business and must survive untouched — the
    // devices list is newest-first so a device just registered is where
    // the admin is looking.
    listed: showRetired ? [...rows] : rows.filter((row) => row.active),
    hiddenCount: rows.filter((row) => !row.active).length,
  };
}
